module.exports = __webpack_public_path__ + "img/newsImg11-24.c87aa999.png";